var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * API service for organization operations.
 */
import { getHeaders, escapeCql } from "./apiUtils";
import { cznaUsersOrganizationsId } from "../types/apiPaths";
var ORGANIZATIONS_ENDPOINT = "czna-users/organizations";
var DEFAULT_LIMIT = 50;
/**
 * Builds a CQL query for organization search with status filtering and sorting.
 */
export var buildOrganizationSearchQuery = function (searchTerm, status, sortBy, sortOrder) {
    var conditions = [];
    if (searchTerm.trim()) {
        var escaped = escapeCql(searchTerm.trim());
        conditions.push("(name==\"*".concat(escaped, "*\" or sigla==\"*").concat(escaped, "*\")"));
    }
    if (status && status !== "ALL") {
        conditions.push("status==\"".concat(status, "\""));
    }
    var query = conditions.length === 0 ? "cql.allRecords=1" : conditions.join(" and ");
    if (sortBy) {
        var order = sortOrder === "descending" ? "sort.descending" : "sort.ascending";
        query += " sortBy ".concat(sortBy, "/").concat(order);
    }
    return query;
};
export var fetchOrganizations = function (ky_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([ky_1], args_1, true), void 0, function (ky, params) {
        var _a, query, _b, offset, _c, limit, searchParams;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_d) {
            _a = params.query, query = _a === void 0 ? "cql.allRecords=1" : _a, _b = params.offset, offset = _b === void 0 ? 0 : _b, _c = params.limit, limit = _c === void 0 ? DEFAULT_LIMIT : _c;
            searchParams = new URLSearchParams();
            searchParams.set("query", query);
            searchParams.set("offset", offset.toString());
            searchParams.set("limit", limit.toString());
            return [2 /*return*/, ky
                    .get("".concat(ORGANIZATIONS_ENDPOINT, "?").concat(searchParams), {
                    headers: getHeaders(),
                })
                    .json()];
        });
    });
};
/** Largest page the organizations endpoint serves (`@Max(500)` on `limit`). */
var MAX_PAGE_SIZE = 500;
/**
 * Every organization the query matches, fetched page by page. For option lists that must
 * be complete (CZNA-1588: the users-list filter): one request would silently stop at the
 * endpoint's page cap.
 */
export var fetchAllOrganizations = function (ky, query) { return __awaiter(void 0, void 0, void 0, function () {
    var all, page;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                all = [];
                _a.label = 1;
            case 1: return [4 /*yield*/, fetchOrganizations(ky, {
                    query: query,
                    offset: all.length,
                    limit: MAX_PAGE_SIZE,
                })];
            case 2:
                page = _a.sent();
                all.push.apply(all, page.items);
                if (page.items.length === 0 || all.length >= page.totalRecords) {
                    return [2 /*return*/, all];
                }
                _a.label = 3;
            case 3: return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * CQL matching any of the given organization ids. The form `id==("a" or "b")` is pinned on the
 * server by `OrganizationRepositoryTest.findByCql_byIdList_returnsOnlyThoseOrganizations`.
 */
export var buildOrganizationIdsQuery = function (ids) {
    return "id==(".concat(ids.map(function (id) { return "\"".concat(escapeCql(id), "\""); }).join(" or "), ")");
};
/**
 * Names of the given organizations, by id, read from the COLLECTION endpoint (CZNA-1611).
 *
 * Not one `GET organizations/{id}` per id: a plain user — every cataloger and local
 * supervisor — is granted `czna-users.organizations.collection.get` but not `item.get`, so
 * the item endpoint answers 403 to exactly the users who look at their own profile. An id the
 * collection does not return is absent from the result; the caller decides how to print it.
 */
export var fetchOrganizationNames = function (ky, ids) { return __awaiter(void 0, void 0, void 0, function () {
    var organizations;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (ids.length === 0)
                    return [2 /*return*/, {}];
                return [4 /*yield*/, fetchAllOrganizations(ky, buildOrganizationIdsQuery(ids))];
            case 1:
                organizations = _a.sent();
                return [2 /*return*/, Object.fromEntries(organizations
                        .filter(function (org) { return org.id && org.name; })
                        .map(function (org) { return [org.id, org.name]; }))];
        }
    });
}); };
export var fetchOrganizationById = function (ky, id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky
                .get(cznaUsersOrganizationsId(id), { headers: getHeaders() })
                .json()];
    });
}); };
